<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h2 class="m-0 poppins-medium mb-2">
              <span class="mr-5"> Tablero </span>
            </h2>
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light bg-principal border mb-2">
      <button class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">  
        <form class="form-inline my-2 my-lg-0" autocomplete="off" @submit.prevent="buscar">
          <input class="form-control form-control-sm mr-sm-2" type="date" v-model="fbusca.fdel">
          <input class="form-control form-control-sm mr-sm-2" type="date" v-model="fbusca.fal">
          <div class="custom-control custom-checkbox mr-4">
            <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="fbusca.todo" :true-value="1" :false-value="0">
            <label class="custom-control-label color-white" for="customCheck1">Ver detalle</label>
          </div>
          <button type="submit" class="btn navbar-btn btn-lg  bg-terce my-2 my-sm-0 color-white">
            <font-awesome-icon icon="search"/> 
          </button>
        </form>
      </div>
    </nav>

    <h4 v-if="cargando" class="text-center">{{ cargandoMsj }}</h4>
    <div v-if="guias !== null">
      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h3 class="text-center">Reintegro CCE</h3>
              <ChartCircle :chartData="datoCce" :height="250"/>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h3 class="text-center">Entregas últimos 7 días</h3>
              <ChartHorizontalBar :chartData="datosUltimosDias" :options="dotro" :height="250"/>
            </div>
          </div>
        </div>
      </div><br>
      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h3 class="text-center">Estado de paquetes</h3>
              <ChartBar :chartData="datoEstatus" :height="250"/>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h3 class="text-center">Entrega de guías</h3>
              <ChartCircle :chartData="datoRangoEntrega" :height="250"/>
            </div>
          </div>
        </div>
      </div><br>
      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <select class="form-control form-control-sm" v-model="verMes">
                    <option v-for="i in listaMes" :key="i" :value="i">{{ i }}</option>
                  </select>
                </div>
                <div class="col-sm-9">
                  <h3 class="text-center">Volumen mensual</h3>
                </div>
              </div>
              <ChartBar :chartData="datosVolumen" :height="250"/>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
        </div>
      </div>
      <br>

      <div class="card" v-if="fbusca.todo == 1">
        <div class="card-body px-2 py-1">
          <div class="table-responsive mt-4">
            <table class="table table-sm table-striped table-bordered table_style" id="tblGuiaTablero">
              <thead>
                <tr>
                  <th colspan="10">
                    <button 
                      type="button" 
                      class="btn btn-sm btn-success"
                      @click="generarExcel({
                        idtabla: 'tblGuiaTablero',
                        extension: 'xls',
                        nombre: 'Guias'
                      })">Excel</button>
                  </th>
                  <th colspan="3">
                    <input type="text" class="form-control form-control-sm" v-model="termino" placeholder="Buscar por número de guía">
                  </th>
                </tr>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Guía</th>
                  <th scope="col">Ref.</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Estado</th>
                  <th scope="col">Destinatario</th>
                  <th scope="col">Monto</th>
                  <th scope="col">Municipio</th>
                  <th scope="col">Departamento</th>
                  <th scope="col">Solicitud</th>
                  <th scope="col">Liquidado</th>
                  <th scope="col">Pagado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i,idx) in filtrada" :key="i.guia_id">
                  <td>{{ idx+1 }}</td>
                  <td>{{ i.numero }}</td>
                  <td>{{ i.indicaciones }}</td>
                  <td>{{ i.creacion }}</td>
                  <td><span class="badge badge-primary">{{ i.guia_estatus }}</span></td>
                  <td>{{ i.nombre }}</td>
                  <td>{{ i.cod_monto }}</td>
                  <td>{{ i.nmunicipio }}</td>
                  <td>{{ i.ndepartamento }}</td>
                  <td>{{ i.numero_recoleccion }}</td>
                  <td>{{ i.cod_liquidado }}</td>
                  <td>{{ i.cod_pagado }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import ChartBar from './ChartBar.vue';
  import ChartCircle from './ChartCircle.vue';
  import ChartHorizontalBar from './ChartHorizontalBar.vue';

  export default {
    name: 'GuiaTablero',
    data: () => {
      return {
        verForm: true,
        cargando: false,
        cargandoMsj: null,
        fbusca: {
          fdel: new Date().toJSON().slice(0,8)+'01',
          fal: new Date().toJSON().slice(0,10)
        },
        guias: null,
        verLista: [],
        detalle: [],
        termino: null,
        verMes: null,
        listaMes: [],
        dotro: {
          responsive: true, 
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1
            }],
            yAxes: [{
              stacked: true
            }]
          }
        }
      }
    },
    mounted () {
      this.buscar();
    },
    methods: {
      buscar() {
        this.cargando = true;
        this.verForm  = !this.verForm;
        this.cargandoMsj = 'Cargando datos...';
        this.guias = null;

        axios
        .get(`${this.UrlBase}/reporte/buscar`, {params:this.fbusca})
        .then(res => {
          if (res.data.exito) {
            this.guias = res.data.datos;
            this.cargando = false;
            if (this.guias.lista) {
              this.detalle = this.guias.lista;
            } else {
              this.detalle = [];
            }
          } else {
            this.cargandoMsj = "No hay datos";
            this.guias = null;
          }
        }).catch(e => {
          this.cargandoMsj = e;
        })
      },
      getColorServicio(servicio) {
        let datos = {
          CCE: '#00a65a',
          SER: '#f56954',
          SEC: '#f39c12'
        };

        if (servicio) {
          return datos[servicio];
        } else {
          return "#24bfbb";
        }
      },
      generarNumero(numero){
        return (Math.random()*numero).toFixed(0);
      },
      colorRGB() {
        var color = this.generarNumero(255)+"," + this.generarNumero(255) + "," + this.generarNumero(255);
        return color;
      },
      generarExcel(args) {
        let tab_text = '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN"><html><head><meta http-equiv="content-type" content="text/html; charset=UTF-8"/><title></title><meta name="generator" content="Gacela C807"/><style type="text/css">body,div,table,thead,tbody,tfoot,tr,th,td,p { font-family:"Liberation Sans"; font-size:x-small }</style></head><body><table>'; 
        let j = 0;
        let tab = document.getElementById(args.idtabla); // id of table

        for(j = 0 ; j < tab.rows.length ; j++) 
        {
          tab_text = tab_text+"<tr>"+tab.rows[j].innerHTML+"</tr>";
        }

        tab_text= tab_text+"</table></body></html>";
        tab_text= tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
        tab_text= tab_text.replace(/<img[^>]*>/gi,""); // remove if u want images in your table
        tab_text= tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // removes input params
        tab_text= tab_text.replace(/<button[^>]*>|<\/button>/gi, ""); // removes input params

        let a = document.createElement('a')
        let formato = 'application/vnd.oasis.opendocument.spreadsheet,'
        let extension = 'ods'
        
        if (args.extension) {
          extension = args.extension
          switch (args.extension) {
            case 'xls':
              formato = 'application/vnd.ms-excel,'
              break;
          
            default:
              extension = 'ods'
              break;
          }
        } 

        a.href = 'data:' + formato + encodeURIComponent(tab_text)
        a.download = args.nombre + '.' + extension
        a.click()

        return false;
      }
    },
    computed: {
      datoCce() {
        let datos = [];
        let label = [];
        let color = [];
        let borde = [];

        for (let i in this.guias.guia_cce) {
          let tmp = this.guias.guia_cce[i];
          let hexa = this.colorRGB();
          color.push(`rgba(${hexa},1)`);
          borde.push(`rgba(${hexa},1)`);
          label.push(tmp.nombre);
          datos.push(tmp.cantidad);
        }

        return {
          labels: label,
          datasets: [
            {
              borderWidth: 1,
              borderColor: borde,
              backgroundColor: color,
              data: datos
            }
          ]
        }
      },
      datoEstatus() {
        let datos = [];
        let label = [];

        for (let i in this.guias.guia_estatus) {
          let tmp = this.guias.guia_estatus[i];

          label.push(tmp.nombre);
          datos.push(tmp.cantidad);
        }

        return {
          labels: label,
          datasets: [
            {
              label: '',
              data: datos,
              backgroundColor: '#ffaa66',
              borderWidth: 1
            }
          ]
        }
      },
      datosUltimosDias() {
        let data = [];

        for (let i in this.guias.guia_ult) {
          let tmp = this.guias.guia_ult[i];

          let valores  = {
            label: i,
            backgroundColor: this.getColorServicio(i),
            data: []
          };

          this.guias.guia_ult_dias.forEach(d => {
            let dat = tmp.filter(e => {
              return e.dia == d;
            });

            if (dat.length > 0) {
              valores.data.push(parseInt(dat[0].total));
            } else {
              valores.data.push(0)
            }
          });

          data.push(valores);
        }

        return {
          labels: this.guias.guia_ult_dias,
          datasets: data
        };
      },
      datosVolumen() {
        let dias  = [];

        this.guias.lista.forEach(e => {
          if (!this.listaMes.includes(e.mes)) {
            this.listaMes.push(e.mes);
            this.verMes = e.mes;
          }
        });

        this.guias.lista.forEach(e => {
          if (e.mes == this.verMes) {
            if (!dias.includes(e.dia)) dias.push(e.dia);
          }
        });

        let datos = [];

        for (let i in dias) {
          let tmp = this.guias.lista.filter(e => {
            return dias[i] == e.dia && e.mes == this.verMes 
          });

          datos.push(tmp.length);
        }

        return {
          labels: dias,
          datasets: [
            {
              label: 'Guías',
              data: datos,
              backgroundColor: 'rgba(60,141,188,0.9)',
              borderWidth: 1
            }
          ]
        }
      },
      datoSubEstatus() {
        let datos = [];
        let label = [];

        for (let i in this.guias.guia_subestatus) {
          let tmp = this.guias.guia_subestatus[i];

          label.push(tmp.nombre);
          datos.push(tmp.cantidad);
        }

        return {
          labels: label,
          datasets: [
            {
              label: '',
              data: datos,
              backgroundColor: '#ffaa66',
              borderWidth: 1
            }
          ]
        }
      },
      datoRangoEntrega() {
        let datos = [];
        let label = [];
        let color = [];
        let borde = [];

        for (let i in this.guias.guia_rango_entrega) {
          let tmp = this.guias.guia_rango_entrega[i];
          let hexa = this.colorRGB();
          color.push(`rgba(${hexa},1)`);
          borde.push(`rgba(${hexa},1)`);
          label.push(tmp.nombre);
          datos.push(tmp.cantidad);
        }

        return {
          labels: label,
          datasets: [
            {
              borderWidth: 1,
              borderColor: borde,
              backgroundColor: color,
              data: datos
            }
          ]
        }
      },
      filtrada () {
        if (this.termino === null) {
          return this.detalle;
        } else {
          return this.detalle.filter(o => {
            return o.numero.includes(this.termino)
          });
        }
      }
    },
    components: {
      ChartBar,
      ChartCircle,
      ChartHorizontalBar
    }
  }
</script>